import React, { useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
//import { Link } from 'react-admin'

import { orange } from '../../constants/colorConstants'

const useStyles = makeStyles((theme) => ({
  file: {
    whiteSpace: 'nowrap',
  },
  text: {
    verticalAlign: 'text-top',
    fontSize: '13px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto500Normal,
  },
  link: {
    color: orange,
    textDecoration: 'underline',
    '& :link': {
      color: orange,
    },
    '& :visited': {
      color: orange,
    },
  },
}))

export const ViewCreditLineField = ({
  source,
  sourceCreditLine,
  record,
  label,
  linkDataCreditLines,
  basePath,
  handleClick,
  ...props
}) => {
  const classes = useStyles()
  const [shouldLink, setShouldLink] = useState(false)
  const [url, setUrl] = useState(undefined)

  const creditLineId = record[sourceCreditLine]

  useEffect(() => {
    if (linkDataCreditLines && creditLineId) {
      const filter = linkDataCreditLines.filter(
        (item) => item.id === creditLineId
      )
      const currentLinkData = filter?.length > 0 ? filter[0] : undefined
      if (currentLinkData === undefined) return setShouldLink(false)
      const page =
        linkDataCreditLines.indexOf(currentLinkData) >= 0
          ? Math.floor(linkDataCreditLines.indexOf(currentLinkData) / 10) + 1
          : 1
      setUrl(
        `/creditlines?page=${page}&perPage=10&selectedItemId=${creditLineId}`
      )
    }
  }, [linkDataCreditLines, creditLineId])

  useEffect(() => {
    if (shouldLink && url !== undefined) {
      setShouldLink(false)
      window.location.href = url
    }
    return () => {
      setShouldLink(false)
    }
  }, [shouldLink, url])

  // const handleInternalClick = () => {
  //   if (url) setShouldLink(true)
  //   if (handleClick) handleClick(record)
  // }

  const importerName = record[source]
    ? record[source]
    : linkDataCreditLines
    ? linkDataCreditLines[0]?.importerName
    : null

  return (
    <Typography
      variant="body2"
      className={classes.file}
      label={label}
      {...props}
      title={importerName}
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '13rem',
      }}
    >
      {url ? (
        // <Link to={url} onClick={handleInternalClick} className={classes.link}>
        <span className={classes.text}>{importerName}</span>
      ) : (
        // </Link>
        <span className={classes.text}>{importerName}</span>
      )}
    </Typography>
  )
}
